import type { FeatureSetting } from '@/features/feature-management/types/featureSetting';

export const DEFAULT_ATTACHMENT_FEATURE_VALUES: AttachmentFeature['featureValues'] =
  {
    maxFileSizeKb: 10_240,
    allowedMediaTypes: [
      'text/plain',
      'text/csv',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    maxNumberAttachmentsPerPost: 5,
    maxNumberAttachmentsPerComment: 5
  };

export type AttachmentFeature = Omit<FeatureSetting, 'featureValues'> & {
  featureValues: {
    maxFileSizeKb: number;
    allowedMediaTypes: string[];
    maxNumberAttachmentsPerPost: number;
    maxNumberAttachmentsPerComment: number;
  };
};
